/**
 * Created by zhengyf on 2018.1.18.
 */

;(function () {

    angular
        .module('DSSXAPP')
        .component('finishPageComponent', {
            template:'<div class="product-post-component product-post-component-finish-page"><div class="success-message"><div class="ui-feedback-success"><h3 class="ui-feedback-header">您的产品信息已经成功提交！</h3><div class="ui-feedback-body"><p>您的产品已经进入审核流程，您可以在24小时之后查询审核结果。 <a href="javascript:;">查看该产品将在哪些类目下展示</a></p></div><div class="success-option-area"><div class="market-info-success-msg"><span>您可以在产品管理页对已有产品信息进行优化，这不仅能提升曝光点击率，更有利于询盘的转化。</span></div><div class="clearfix"><a href="product-manage.html" class="btn-ms">管理产品</a><div class="success-next-step">您还可以 <a href="product-post.html">继续发布新产品</a></div></div></div></div></div></div>',
            binding: {

            },
            controllerAs: 'vm',
            controller: FinishPageCtrl
        });

    function FinishPageCtrl() {

        this.$onInit = onInit;
        this.$onChanges = bindingsOnChanges;

        var vm = this;


        function onInit() {
            console.log('[FinishPageCtrl init: ]');
        }

        function bindingsOnChanges(changes) {

        }

    }

})();
